import PublicLayout from "@/components/layouts/bootstrap/PublicLayout";
import Head from "next/head";
import Link from "next/link";
import { useRouter } from "next/router";
import { Image } from 'react-bootstrap';

export default function Industry()
{
    const router = useRouter();
    return (
        <>
            <Head>
                <title>Audience Response System | Interactive Polling</title>
                <meta name="description" content="Engage users with real-time audience response system." />
            </Head>

            <section className="hero-reseller business-reseller d-flex align-items-center text-white">
                <div className="container hero-inner">
                    <div className="hero-copy d-inline-block">
                        <h1 className="publicBannerHeading">Business & Leadership

                        </h1>
                    </div>
                </div>
                <Link
                    className="btn btn-info text-white mt-3 float-end"
                    href="/industry_questions"
                >
                    VIEW EXPERT QUESTIONS
                </Link>

            </section>
            <section className="py-5 bg-white">

                <div className="container">
                    <div className="mb-4">
                        <button
                            onClick={() => router.back()}
                            className="button btn-purple me-3 text-uppercase border-0 p-2 px-3"
                        >
                            Back
                        </button>
                        <Link className="button btn-purple me-3" href="/contact">BOOK A DEMO</Link>
                        <Link className="button btn-purple me-3" href="/register">REGISTER</Link>
                        <Link className="button btn-purple me-3" href="/pricing">PRICING</Link>
                        <Link className="button btn-purple me-3" href="/register">TRY A FREE POLL</Link>

                        <Link className="button btn-purple" href="/faq">FAQ</Link>
                    </div>
                    <div className="row align-items-center">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <h2 className="fw-bold  mb-4 secondaryColor" >
                                {/* Lead with clarity. <br />Decide in the moment. */}
                                Lead with clarity using real-time feedback. Decide in the moment with live polling and data-driven decision-making.
                            </h2>
                            <p className="text-muted mb-3">
                                In leadership, timing is everything. Strategic <b> decision-making</b> can&#39;t wait for lagging reports, and <b> organisational alignment </b> can’t depend on guesswork.
                            </p>
                            <p className="text-muted mb-3">
                                When you&#39;re in a boardroom, leading a <b> virtual town hall</b>, or driving <b> employee engagement </b> across regions, Instant Polls turns<b> real-time feedback </b> into actionable insight. Launch branded <b> live polls</b> in seconds, capture authentic sentiment instantly, and make informed calls while the moment still matters.
                            </p>
                            <p className="text-muted">
                                Because better questions lead to better <b> business decisions </b> — and better outcomes.
                            </p>
                        </div>

                        <div className="col-lg-6 text-center">
                            <Image src="/industry/business-leadership-polling.png" alt="business leadership polling tool for executive teams" className="img-fluid" />
                        </div>
                    </div>
                </div>

            </section>

            <section className="py-5 bg-blue">

                <div className="container text-center">
                    <div className="row g-5">
                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start" >The Challenge</h5>
                                    <p className="card-text text-muted">
                                        Traditional <b> survey software</b> is built for research, not immediate response. <b>Instant Polls</b> change that. </p>
                                    <p className="card-text text-muted">
                                        Existing tools are slow, disconnected, and designed for <b> data collection</b> long after the moment has passed. Leaders end up reacting to lagging <b> employee feedback</b> instead of guiding with live clarity. Our platform brings <b> real-time engagement </b> and <b> team alignment </b> into the now.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start" >The Solution</h5>
                                    <p className="card-text text-muted">
                                        From <b>executive leadership </b> teams to global <b>enterprise networks</b>, Instant Polls helps leaders turn <b>real-time feedback</b> into strategic foresight. It creates trust in your data, unity in direction, and confidence in every <b>data-driven decision</b>.</p>
                                    <p className="card-text text-muted">
                                        Because when you ask the right question at the right time using <b>interactive polling</b>, corporate strategy becomes immediate action.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset" >
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start" >The Result</h5>
                                    <p className="card-text text-muted">
                                        From <b>executive leadership </b>teams to global <b>enterprise networks</b>, Instant Polls helps leaders turn <b>real-time feedback</b> into strategic foresight. It builds trust in <b>data-driven insights</b>, unity in direction, and confidence in every <b>business decision</b>.
                                    </p>
                                    <p className="card-text text-muted">
                                        Because when you ask the right questions using <b>interactive tools</b>, your <b> leadership communication</b> and strategy become immediate action.

                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="features py-5">
                <div className="container">
                    <h2 className="text-center fw-bold mb-4 highlightedColor">How Instant Polls Works</h2>
                    <div className="row g-4">
                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/dashboard.png" alt="polls analytics dashboard icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Real-Time Dashboards</div>
                                    <p className="rfeature-text">Result stream in live, no refresh required.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/artificial-intelligence.png" alt="AI-powered polling intelligence icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">AI-Powered Sentiment</div>
                                    <p className="rfeature-text">Understand tone and context, not just raw numbers.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/segmentation.png" alt="audience segmentation icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Segmentation</div>
                                    <p className="rfeature-text">Break results down by department, region, or demographics.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/system.png" alt="system integration icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Seamless Integration</div>
                                    <p className="rfeature-text">Works with Microsoft Teams, Slack, CRMs, and more.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/cyber-security-icon.png" alt="data security and privacy icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Enterprise-Grade Security</div>
                                    <p className="rfeature-text">Anonymous by default, encrypted end-to-end</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/outline.png" alt="reporting and insights icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">White-Label Branding</div>
                                    <p className="rfeature-text">Brand every poll as your own.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5 publicNewBgvColor">
                <div className="container testimonials">
                    <h2 className="mb-5 text-purple">Hear From Our Users</h2>
                    <div className="row g-4">
                        <div className="col-md-4">
                            <div className="bs-quotes">
                                <p>“Instant Polls changed how we run leadership meetings. We get clarity in minutes instead of waiting on surveys.”</p>
                                <cite>Managing Director, Professional Services</cite>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="bs-quotes">
                                <p>“As an event organiser, I finally have live engagement metrics to show sponsors real ROI.”</p>
                                <cite>Event Manager</cite>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="bs-quotes">
                                <p>“Our students love it. Real-time feedback makes learning more interactive.”</p>
                                <cite>University Lecturer</cite>
                            </div>
                        </div>
                    </div>
                </div>
            </section >

            <section className="lead-section d-flex align-items-center">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 py-5">
                            <h3 className="fw-bold mb-3 secondaryColor" >Ready to lead with clarity?</h3>
                            <p className="text-muted mb-3">
                                Discover how Instant Polls can transform your <b>strategic leadership</b> and the way your organisation engages,
                                decides, and leads — in real time. Our <b>audience response system</b> is built for leaders who move fast,
                                think clearly, and refuse to wait for yesterday’s data. Whether you&#39;re managing a national team,
                                presenting to a <b>corporate board</b>, or shaping a company-wide strategy,
                                Instant Polls delivers the <b>real-time insights</b> that turn discussion into direction.
                            </p>
                            <p className="text-muted mb-4">
                                Experience how <b>interactive polling</b> can sharpen <b>team alignment</b>, inspire confidence, and accelerate every <b> data-driven decision</b>.

                            </p>
                            <div className="d-flex flex-column flex-lg-row flex-wrap gap-3">
                                <Link href="/pricing" className="btn btn-purple rounded-pill px-4 py-2" >See Pricing Plans</Link>
                                <Link href="/contact" className="btn btn-info rounded-pill px-4 py-2 text-white">Try a Business Demo</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

Industry.getLayout = (page) => <PublicLayout>{page}</PublicLayout>;
